import apiInstance from "../api";
import endPoints from "../endpoints";

// approval count data
export const getApprovalWithdrawalCount = (payload) => {
  return apiInstance().get(
    `${endPoints.transactions.getApprovalWithdrawalCount}/${payload}`
  );
};
export const getLoanById = (payload) => {
  return apiInstance().get(`${endPoints.transactions.getLoanById}/${payload}`);
};
export const getInProgressLoan = (id) => {
  return apiInstance().get(
    `${endPoints.transactions.getInProgressLoanDetails}/${id}`
  );
};
export const getApprovalLoanCount = () => {
  return apiInstance().get(
    `${endPoints.transactions.getLoanAwaitingForApprovalCount}`
  );
};
export const getApprovalRolloverinCount = () => {
  return apiInstance().get(
    `${endPoints.transactions.getApprovalRolloverinCount}`
  );
};

//approval employeeData in card(list)
export const getApprovalWithdrawalEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getApprovalWithdrawalEmployee,
    payload
  );
};

export const getApprovalLoanEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getApprovalLoanEmployee,
    payload
  );
};

export const getApprovalRolloverinEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getApprovalRolloverinEmployee,
    payload
  );
};

//draft employeeData in card
export const getDraftWithdrawalEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getDraftWithdrawalEmployee,
    payload
  );
};
export const getDraftLoanEmployee = (payload) => {
  return apiInstance().post(endPoints.trade.getDrafLoanEmployee, payload);
};
export const getDraftRolloverinEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getDraftRolloverinEmployee,
    payload
  );
};

export const getWithDrawalApprovalSearchinEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getWithDrawalApprovalSearchinEmployee,
    payload
  );
};

//searchFilterApproval(post)
export const getLoanApprovalSearchinEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getLoanApprovalSearchinEmployee,
    payload
  );
};

export const getRolloverinApprovalSearchinEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getRolloverinApprovalSearchinEmployee,
    payload
  );
};

// export const getWithDrawalApprovalSearchinEmployee = (payload) => {
//   return apiInstance().post(
//     endPoints.transactions.getWithDrawalApprovalSearchinEmployee,
//     payload
//   );
// };

//searchFilterDraft(post)
export const getRollOverinDraftSearchinEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getRollOverinDraftSearchinEmployee,
    payload
  );
};

export const getWithdrawalsDraftSearchinEmployee = (payload) => {
  return apiInstance().post(
    endPoints.transactions.getWithdrawalsDraftSearchinEmployee,
    payload
  );
};

// draft data count
export const getDraftWithdrawalCount = (payload) => {
  return apiInstance().get(
    `${endPoints.transactions.getDraftWithdrawalCount}/${payload}`
  );
};
export const getDraftLoanCount = () => {
  return apiInstance().get(`${endPoints.transactions.getDraftLoanCount}`);
};
export const getDraftRolloverinCount = () => {
  return apiInstance().get(`${endPoints.transactions.getDraftRolloverinCount}`);
};

//delete draft
export const deleteRollOverInRequest = (id) => {
  return apiInstance().get(
    `${endPoints.transactions.deleteRollOverInRequest}/${id}`
  );
};

export const deleteWithdrawalRequest = (id) => {
  return apiInstance().delete(
    `${endPoints.transactions.deleteWithdrawalRequest}/${id}`
  );
};

export const deleteLoanRequest = (id) => {
  return apiInstance().post(
    `${endPoints.transactions.deleteLoanRequest}/${id}`
  );
};

//transfers
export const getCurrentHoldings = (employeeId) => {
  return apiInstance().get(
    `${endPoints.transactions.getCurrentHoldings}/${employeeId}`
  );
};

export const getInvestmentsByPlanId = (planId) => {
  return apiInstance().get(
    `${endPoints.transactions.getInvestmentsByPlanId}/${planId}`
  );
};

export const saveTransferDetails = (payload) => {
  return apiInstance().post(
    endPoints.transactions.saveTransferDetails,
    payload
  );
};

export const saveDraftOfTransferDetails = (payload) => {
  return apiInstance().post(
    endPoints.transactions.saveDraftOfTransferDetails,
    payload
  );
};

export const getTransferDetails = (employeeId) => {
  return apiInstance().get(
    `${endPoints.transactions.getTransferDetails}/${employeeId}`
  );
};

export const getTransferRequestDetailsByEmpId = (employeeId) => {
  return apiInstance().get(
    `${endPoints.transactions.getTransferRequestDetailsByEmpId}/${employeeId}`
  );
};

export const deleteTransferRequest = (transferRequestId) => {
  return apiInstance().delete(
    `${endPoints.transactions.deleteTransferRequest}/${transferRequestId}`
  );
};

//rebalance
export const saveRebalanceDetails = (payload) => {
  return apiInstance().post(
    endPoints.transactions.saveRebalanceDetails,
    payload
  );
};

export const saveDraftOfRebalanceDetails = (payload) => {
  return apiInstance().post(
    endPoints.transactions.saveDraftOfRebalanceDetails,
    payload
  );
};

export const getRebalanceDetails = (employeeId) => {
  return apiInstance().get(
    `${endPoints.transactions.getRebalanceDetails}/${employeeId}`
  );
};

export const getRebalanceRequestDetailsByEmpId = (employeeId) => {
  return apiInstance().get(
    `${endPoints.transactions.getRebalanceRequestDetailsByEmpId}/${employeeId}`
  );
};

export const deleteRebalanceRequest = (rebalanceRequestId) => {
  return apiInstance().delete(
    `${endPoints.transactions.deleteRebalanceRequest}/${rebalanceRequestId}`
  );
};

export const approveLoan = (payload) => {
  return apiInstance().post(`${endPoints.transactions.approveLoan}/${payload}`);
};

export const rejectLoan = (payload) => {
  return apiInstance().post(endPoints.transactions.rejectLoan, payload);
};

export const getEmployeeEligiblePlanLoans = (id) => {
  return apiInstance().get(
    `${endPoints.transactions.getEmployeeEligiblePlanLoans}/${id}`
  );
};
